/**
 * Adee size chart.
 *
 * The guide is split across several sections (controls + tables, how-to-measure,
 * SEO cards) that a merchant can reorder or remove in the theme editor, so this
 * coordinates them at the document level via data attributes rather than owning
 * a single section's DOM. Every part is optional: if a section isn't on the page,
 * the corresponding step is simply skipped.
 */
(function () {
  'use strict';

  var DEFAULT_SUBTAB = { baby: 'stretchies', girls: 'gdresses', boys: 'btops' };

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function showCategory(cat) {
    all('[data-adee-panel]').forEach(function (p) {
      p.classList.toggle('is-on', p.getAttribute('data-adee-panel') === cat);
    });
    all('[data-adee-cat]').forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-adee-cat') === cat ? 'true' : 'false');
    });
    all('[data-adee-seo]').forEach(function (s) {
      s.style.display = s.getAttribute('data-adee-seo') === cat ? 'block' : 'none';
    });
    showSubtab(DEFAULT_SUBTAB[cat]);
  }

  function showSubtab(id) {
    if (!id) return;
    var panel = document.querySelector('[data-adee-panel].is-on');
    if (panel) {
      all('[data-adee-subtab]', panel).forEach(function (b) {
        var on = b.getAttribute('data-adee-subtab') === id;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.classList.toggle('is-on', on);
      });
      all('[data-adee-subpanel]', panel).forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-adee-subpanel') === id);
      });
    }
    // How-to-measure lives in its own section, so search the whole document.
    all('[data-adee-how]').forEach(function (el) {
      el.style.display = el.getAttribute('data-adee-how') === id ? 'block' : 'none';
    });
  }

  function setUnit(unit) {
    // Every section wraps itself in .adee-size-chart; the metric class drives
    // the in/cm swap inside all of them.
    all('.adee-size-chart').forEach(function (w) { w.classList.toggle('metric', unit === 'metric'); });
    all('[data-adee-unit]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-adee-unit') === unit);
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-adee-cat],[data-adee-subtab],[data-adee-unit]');
    if (!el) return;
    if (el.hasAttribute('data-adee-cat')) showCategory(el.getAttribute('data-adee-cat'));
    else if (el.hasAttribute('data-adee-subtab')) showSubtab(el.getAttribute('data-adee-subtab'));
    else setUnit(el.getAttribute('data-adee-unit'));
  });

  function init() {
    if (!document.querySelector('.adee-size-chart')) return;
    var active = document.querySelector('[data-adee-cat][aria-selected="true"]');
    showCategory(active ? active.getAttribute('data-adee-cat') : 'baby');
    setUnit(document.querySelector('.adee-size-chart.metric') ? 'metric' : 'imperial');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // The theme editor re-renders a section on every settings change, which wipes
  // the is-on classes this script applies. Re-run whenever that happens.
  document.addEventListener('shopify:section:load', init);
})();
